import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/features/domru-bonus/styled';

const ICON_SIZE = '58px';
const ICON_SIZE_MOBILE = '65px';

export const IconBlock = styled.div`
    width: ${ICON_SIZE};
    height: ${ICON_SIZE};
    margin-right: 19px;
    background: url('/static/images/icons/bonus-rings.svg') 0 0 / cover no-repeat;

    @media (max-width: ${breakPoints.mobile}) {
        width: ${ICON_SIZE_MOBILE};
        height: ${ICON_SIZE_MOBILE};
        margin-right: 0;
        margin-bottom: 19px;
    }
`;

export const ResponsePopup = styled(DefaultPopup)`
    padding: 50px;
    width: calc(100% - 20px) !important;
    max-width: 896px !important;
    @media (max-width: 1024px) {
        max-width: 690px !important;
    }
    @media (max-width: 800px) {
        max-width: 530px !important;
    }
`;

export const Title = styled.div`
    display: block;
    margin-top: 20px;
    ${FONTS.H2};

    @media (max-width: 767px) {
        ${FONTS.H4};
    }
`;

export const Text = styled.div`
    display: block;
    margin-top: 5px;
    ${FONTS.S};

    @media (max-width: 767px) {
        ${FONTS.XS};
    }
`;

export const Button = styled(BaseButton)`
    margin-top: 30px;
    max-width: 220px;

    @media (max-width: ${breakPoints.laptop}) {
        max-width: unset;
        width: 230px;
    }
`;
